import "../App.css";
import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import {
  call,
  pay,
  payCompleted,
  payCancel,
  payFail,
  pays,
  addBasket,
} from "../service/ApiService";
import {
  //Container,
  List,
  Paper,
  //Grid,
  // Button,
  // AppBar,
  // Toolbar,
  //Typography,
} from "@mui/material";

export function AddBasket() {
  // pay?basket=402880828b0fce5b018b0fcebef80000
  const params = new URLSearchParams(window.location.search);
  let item = params.get("item");
  addBasket({ id: item, count: 1 });
  //장바구니id

  alert("dkdwd");

  /*
  const [items, setItems] = useState([]);

  useEffect(() => {
    //effect 훅 //랜더링 후에 수행 이후  []의 오브젝트가 변경되면 수행
    call("/admin/userList", "POST", "").then((response) => {
      if (response) {
        setItems(response.data);
      }
    });
  }, []);

  let todoItems = items.length > 0 && (
    <Paper style={{ margin: 16 }}>
      <List>
        {items.map((item) => (
          <div item={item} key={item.id}>
            {item.id}
            {" -- "}
            {item.username}
          </div>
        ))}
      </List>
    </Paper>
  );
  */

  /* 장애일 때 렌더링 할 부분 */
  //let loadingPage = <h1> admin.. </h1>;
  //let content = todoItems;
  let content = "loading..";
  /* 선택한 content 렌더링 */
  return <div className="loading">{content}</div>;
}

export function Pay() {
  // pay?basket=402880828b0fce5b018b0fcebef80000
  const params = new URLSearchParams(window.location.search);
  let basket = params.get("basket");
  pay({ id: basket });
  //장바구니id

  /*
  const [items, setItems] = useState([]);

  useEffect(() => {
    //effect 훅 //랜더링 후에 수행 이후  []의 오브젝트가 변경되면 수행
    call("/admin/userList", "POST", "").then((response) => {
      if (response) {
        setItems(response.data);
      }
    });
  }, []);

  let todoItems = items.length > 0 && (
    <Paper style={{ margin: 16 }}>
      <List>
        {items.map((item) => (
          <div item={item} key={item.id}>
            {item.id}
            {" -- "}
            {item.username}
          </div>
        ))}
      </List>
    </Paper>
  );
  */

  /* 장애일 때 렌더링 할 부분 */
  //let loadingPage = <h1> admin.. </h1>;
  //let content = todoItems;
  let content = "loading..";
  /* 선택한 content 렌더링 */
  return <div className="loading">{content}</div>;
}

export function PayServer() {
  // pays?basket=402880828b0fce5b018b0fcebef80000
  const params = new URLSearchParams(window.location.search);
  let basket = params.get("basket");
  //console.log("basket :" + basket);
  pays({ basket: basket });

  /* 장애일 때 렌더링 할 부분 */
  //let loadingPage = <h1> admin.. </h1>;
  //let content = todoItems;
  let content = "loading..";
  /* 선택한 content 렌더링 */
  return <div className="loading">{content}</div>;
}

export function Completed() {
  //const { pg_token } = useParams();
  const params = new URLSearchParams(window.location.search);
  let pgToken = params.get("pg_token");
  //console.log("pgToken :" + params);
  //payCompleted({ pg_token: pgToken });
  payCompleted({ id: pgToken });

  /*
  const [items, setItems] = useState([]);

  useEffect(() => {
    //effect 훅 //랜더링 후에 수행 이후  []의 오브젝트가 변경되면 수행
    call("/admin/userList", "POST", "").then((response) => {
      if (response) {
        setItems(response.data);
      }
    });
  }, []);

  let todoItems = items.length > 0 && (
    <Paper style={{ margin: 16 }}>
      <List>
        {items.map((item) => (
          <div item={item} key={item.id}>
            {item.id}
            {" -- "}
            {item.username}
          </div>
        ))}
      </List>
    </Paper>
  );
  */

  /* 장애일 때 렌더링 할 부분 */
  //let loadingPage = <h1> admin.. </h1>;
  //let content = todoItems;
  let content = "loading..";
  /* 선택한 content 렌더링 */
  return <div className="loading">{content}</div>;
}

export function Cancel() {
  //alert();
  window.close();
  window.location.href = "/basketList";
  //const { pgToken } = useParams();
  //payCompleted({ pgToken: pgToken });
  //payCancel({ id: "" });

  /*
  const [items, setItems] = useState([]);

  useEffect(() => {
    //effect 훅 //랜더링 후에 수행 이후  []의 오브젝트가 변경되면 수행
    call("/admin/userList", "POST", "").then((response) => {
      if (response) {
        setItems(response.data);
      }
    });
  }, []);

  let todoItems = items.length > 0 && (
    <Paper style={{ margin: 16 }}>
      <List>
        {items.map((item) => (
          <div item={item} key={item.id}>
            {item.id}
            {" -- "}
            {item.username}
          </div>
        ))}
      </List>
    </Paper>
  );
  */

  /* 장애일 때 렌더링 할 부분 */
  //let loadingPage = <h1> admin.. </h1>;
  //let content = todoItems;
  let content = "loading..";
  /* 선택한 content 렌더링 */
  return <div className="loading">{content}</div>;
}

export function Fail() {
  //alert();
  window.close();
  window.location.href = "/basketList";

  //const { pgToken } = useParams();
  payFail({ id: "" });

  /*
  const [items, setItems] = useState([]);

  useEffect(() => {
    //effect 훅 //랜더링 후에 수행 이후  []의 오브젝트가 변경되면 수행
    call("/admin/userList", "POST", "").then((response) => {
      if (response) {
        setItems(response.data);
      }
    });
  }, []);

  let todoItems = items.length > 0 && (
    <Paper style={{ margin: 16 }}>
      <List>
        {items.map((item) => (
          <div item={item} key={item.id}>
            {item.id}
            {" -- "}
            {item.username}
          </div>
        ))}
      </List>
    </Paper>
  );
  */

  /* 장애일 때 렌더링 할 부분 */
  //let loadingPage = <h1> admin.. </h1>;
  //let content = todoItems;
  let content = "loading..";
  /* 선택한 content 렌더링 */
  return <div className="loading">{content}</div>;
}

////
///
///
///
export function Fail22() {
  //alert();
  window.location.href = "/basketList";
  //const { pgToken } = useParams();
  payFail({ id: "" });

  /* 장애일 때 렌더링 할 부분 */
  //let loadingPage = <h1> admin.. </h1>;
  //let content = todoItems;
  let content = "loading..";
  /* 선택한 content 렌더링 */
  return <div className="loading">{content}</div>;
}
